import { DC } from "../../constants";

export const normalAchievements = [
  {
    id: 11,
    name: "Все мы с этого начинали",
    description: "Купите 1ое Измерение Антиматерии.",
    checkEvent: GAME_EVENT.ACHIEVEMENT_EVENT_OTHER,
  },
  {
    id: 12,
    name: "100 антиматерии - это много",
    description: "Купите 2ое Измерение Антиматерии.",
    checkEvent: GAME_EVENT.ACHIEVEMENT_EVENT_OTHER,
  },
  {
    id: 13,
    name: "Халф Лайф 3 ПОДТВЕРЖДЁНО",
    description: "Купите 3е Измерение Антиматерии.",
    checkEvent: GAME_EVENT.ACHIEVEMENT_EVENT_OTHER,
  },
  {
    id: 14,
    name: "О4И: Осталось 4 Измерения",
    description: "Купите 4ое Измерение Антиматерии.",
    checkEvent: GAME_EVENT.ACHIEVEMENT_EVENT_OTHER,
  },
  {
    id: 15,
    name: "Пятимерный Удар",
    description: "Купите 5ое Измерение Антиматерии.",
    checkEvent: GAME_EVENT.ACHIEVEMENT_EVENT_OTHER,
  },
  {
    id: 16,
    name: "У нас не хватало на 9",
    get description() {
      return Enslaved.isRunning
        ? "Купите 6ое Измерение Антиматерии (они ничего ни к чему не прибавляют)"
        : "Купит 6ое Измерение Антиматерии.";
    },
    checkEvent: GAME_EVENT.ACHIEVEMENT_EVENT_OTHER,
  },
  {
    id: 17,
    name: "Достижение никак не связанное с удачей",
    description: "Купите 7ое Измерение Антиматерии.",
    checkEvent: GAME_EVENT.ACHIEVEMENT_EVENT_OTHER,
  },
  {
    id: 18,
    name: "90 градусов до бесконечности",
    get description() {
      return Enslaved.isRunning
        ? "Купите 8ое Измерение Антиматерии (не особо к этому привыкай)"
        : "Купите 8ое Измерение Антиматерии.";
    },
    checkEvent: GAME_EVENT.ACHIEVEMENT_EVENT_OTHER,
  },
  {
    id: 21,
    name: "Бесконечность - не...",
    description: "Бесконечнизируйтесь.",
    checkRequirement: () => true,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() { return `Начинайте с ${formatInt(100)} антиматерии.`; },
    effect: 100
  },
  {
    id: 22,
    name: "ФЭЙК НЬЮС!",
    get description() { return `Наткнитесь на ${formatInt(50)} различных новостных сообщений.`; },
    checkRequirement: () => NewsHandler.uniqueTickersSeen >= 50,
    checkEvent: GAME_EVENT.REALITY_RESET_AFTER
  },
  {
    id: 23,
    name: "9ое Измерение это ложь",
    get description() { return `Имейте ровно ${formatInt(99)} 8ых Измерений Антиматерии.`; },
    checkRequirement: () => AntimatterDimension(8).amount.eq(99),
    get reward() { return `8ые Измерения Антиматерии на ${formatPercents(0.1)} сильнее.`; },
    effect: 1.1
  },
  {
    id: 24,
    name: "Апокалипсис Антиматерии",
    get description() { return `Преодолейте число в ${format(DC.E80)} антиматерии.`; },
    checkRequirement: () => Currency.antimatter.exponent >= 80,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER
  },
  {
    id: 25,
    name: "Бустим до максимума",
    get description() { return `Купите ${formatInt(10)} Бустов Измерений.`; },
    checkRequirement: () => DimBoost.purchasedBoosts >= 10,
    checkEvent: GAME_EVENT.DIMBOOST_AFTER
  },
  {
    id: 26,
    name: "Вы перешли через Большую Стену",
    description: "Купите Галактику Антиматерии.",
    checkRequirement: () => true,
    checkEvent: GAME_EVENT.GALAXY_RESET_BEFORE
  },
  {
    id: 27,
    name: "Двойная Галактика",
    get description() { return `Купите ${formatInt(2)} Галактики Антиматерии.`; },
    checkRequirement: () => player.galaxies >= 2,
    checkEvent: GAME_EVENT.GALAXY_RESET_AFTER
  },
  {
    id: 28,
    name: "Это лишено всякого смысла...",
    get description() {
      return `Купите одно единственное 1ое Измерение Антиматерии, когда у вас их больше ${format(DC.E150)}.`;
    },
    checkRequirement: () => AntimatterDimension(1).amount.exponent >= 150,
    checkEvent: GAME_EVENT.ACHIEVEMENT_EVENT_OTHER,
    get reward() { return `1ые Измерения Антиматерии на ${formatPercents(0.1)} сильнее.`; },
    effect: 1.1
  },
  {
    id: 31,
    name: "Я забыл ослабить это",
    get description() { return `Получите любой из множителей Измерений Антиматерии больше ${formatX(DC.E31)}.`; },
    checkRequirement: () => AntimatterDimensions.all.some(x => x.multiplier.exponent >= 31),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    get reward() { return `1ые Измерения Антиматерии на ${formatPercents(0.05)} сильнее.`; },
    effect: 1.05
  },
  {
    id: 32,
    name: "Боги довольны",
    get description() { return `Получите более ${formatX(600)} от Жертвования Измерений снаружи Челленджа 8.`; },
    checkRequirement: () => !NormalChallenge(8).isOnlyActiveChallenge && Sacrifice.totalBoost.gte(600),
    checkEvent: GAME_EVENT.SACRIFICE_RESET_AFTER,
    get reward() {
      return `Жертвование Измерений Сильнее.
      ${Sacrifice.getSacrificeDescription({ "Achievement32": false, "Achievement57": false, "Achievement88": false })} ➜
      ${Sacrifice.getSacrificeDescription({ "Achievement32": true, "Achievement57": false, "Achievement88": false })}`;
    },
    effect: 0.1,
  },
  {
    id: 33,
    name: "Это много Бесконечностей",
    get description() { return `Достигните Бесконечности ${formatInt(10)} раз.`; },
    checkRequirement: () => Currency.infinities.gte(10),
    checkEvent: GAME_EVENT.BIG_CRUNCH_AFTER
  },
  {
    id: 34,
    name: "Ты всё равно его не используешь",
    description: "Бесконечность без 8ых Измерений Антиматерии.",
    checkRequirement: () => AntimatterDimension(8).totalAmount.eq(0),
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() { return `Измерения 1-7 на ${formatPercents(0.02)} сильнее.`; },
    effect: 1.02
  },
  {
    id: 35,
    name: "Даже не вздумай спать",
    get description() {
      return PlayerProgress.realityUnlocked()
        ? `Будьте офлайн более ${formatInt(6)} часов (реального времени).`
        : `Будьте офлайн более ${formatInt(6)} часов.`;
    },
    checkRequirement: () => Date.now() - player.lastUpdate >= 21600000,
    checkEvent: GAME_EVENT.GAME_TICK_BEFORE
  },
  {
    id: 36,
    name: "Клаустрофоб",
    get description() {
      return `Бесконечность всего с ${
        formatInt(1)} Галактикой Антиматерии. (Галактики Антиматерии сбрасываются при Бесконечности.)`;
    },
    checkRequirement: () => player.galaxies === 1,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() { return `Стартовая Скорость Тика умножена на ${format(1.02, 2, 2)}.`; },
    effect: 1 / 1.02
  },
  {
    id: 37,
    name: "Это БЫСТРО!",
    get description() { return `Бесконечность быстрее чем за ${formatInt(2)} часа.`; },
    checkRequirement: () => Time.thisInfinityRealTime.totalHours <= 2,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() { return `Начните с ${formatInt(5000)} антиматерии.`; },
    effect: 5000
  },
  {
    id: 38,
    name: "Я не верю в Богов",
    get description() {
      return `Купите Галактику Антиматерии без Жертвования Измерений.
        (Галактики Антиматерии сбрасываются после Бесконечности.)`;
    },
    checkRequirement: () => player.requirementChecks.infinity.noSacrifice,
    checkEvent: GAME_EVENT.GALAXY_RESET_BEFORE
  },
  {
    id: 41,
    name: "ДЛЦ не требуется",
    get description() { return `Купите ${formatInt(16)} Улучшений Бесконечности.`; },
    checkRequirement: () => player.infinityUpgrades.size >= 16,
    checkEvent: [
      GAME_EVENT.INFINITY_UPGRADE_BOUGHT,
      GAME_EVENT.REALITY_RESET_AFTER,
      GAME_EVENT.REALITY_UPGRADE_TEN_BOUGHT
    ],
    get reward() {
      return `Открывает два новых Улучшения Бесконечности- ${formatX(2)} ОБ множитель и офлайн генерацию ОБ.`;
    },
  },
  {
    id: 42,
    name: "Супер Саник",
    get description() {
      return `Имейте антиматерии в секунду больше, чем ваша текущая антиматерия, на числах после ${format(DC.E63)}.`;
    },
    checkRequirement: () =>
      Currency.antimatter.exponent >= 63 &&
      Currency.antimatter.productionPerSecond.gt(Currency.antimatter.value),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER
  },
  {
    id: 43,
    name: "Вот это Антиповорот!",
    description:
      "Сделайте множитель 8ого Измерения самым большим, 7ого вторым наибольшим, 6ого третьим наибольшим и так далее" +
      ".",
    checkRequirement: () => {
      const multipliers = Array.range(1, 8).map(tier => AntimatterDimension(tier).multiplier);
      for (let i = 0; i < multipliers.length - 1; i++) {
        if (multipliers[i].gte(multipliers[i + 1])) return false;
      }
      return true;
    },
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    get reward() {
      return `Каждое Измерение Антиматерии получает бонус пропорционально уровню
      (8ое получает ${formatPercents(0.08)}, 7ое получает ${formatPercents(0.07)}, и так далее)`;
    }
  },
  {
    id: 44,
    name: "Кончил за 30 секунд",
    get description() {
      return `Имейте антиматерии в секунду больше, чем вашей антиматерии,
      ${formatInt(30)} секунд подряд.`;
    },
    checkRequirement: () => AchievementTimers.marathon1
      .check(Currency.antimatter.productionPerSecond.gt(Currency.antimatter.value), 30),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
  },
  {
    id: 45,
    name: "Быстрее чем картошина",
    get description() { return `Получите более чем ${format(DC.E29)} тиков в секунду.`; },
    checkRequirement: () => Tickspeed.current.exponent <= -26,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    get reward() { return `Умножить стартовую скорость тика на ${formatX(1.02, 0, 2)}.`; },
    effect: 0.98
  },
  {
    id: 46,
    name: "Многомерный",
    get description() { return `Достигните ${format(DC.E12)} всех Измерений Антиматерии кроме 8ого.`; },
    checkRequirement: () => AntimatterDimension(7).amount.exponent >= 12,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER
  },
  {
    id: 47,
    name: "Сорвиголова",
    get description() { return `Пройдите ${formatInt(3)} Нормальных Челленджа.`; },
    checkRequirement: () => NormalChallenges.all.countWhere(c => c.isCompleted) >= 3,
    checkEvent: [GAME_EVENT.BIG_CRUNCH_AFTER, GAME_EVENT.REALITY_RESET_AFTER, GAME_EVENT.REALITY_UPGRADE_TEN_BOUGHT],
  },
  {
    id: 48,
    name: "Антииспытанный",
    get description() { return `Пройдите ${formatInt(12)} Нормальных Челленджей.`; },
    checkRequirement: () => NormalChallenges.all.countWhere(c => !c.isCompleted) === 0,
    checkEvent: [GAME_EVENT.BIG_CRUNCH_AFTER, GAME_EVENT.REALITY_RESET_AFTER, GAME_EVENT.REALITY_UPGRADE_TEN_BOUGHT],
    get reward() { return `Все измерения на ${formatPercents(0.1)} сильнее.`; },
    effect: 1.1
  },
  {
    id: 51,
    name: "...предел!",
    description: "Преодолейте Бесконечность.",
    checkRequirement: () => player.break,
    checkEvent: [GAME_EVENT.BREAK_INFINITY, GAME_EVENT.REALITY_RESET_AFTER, GAME_EVENT.REALITY_UPGRADE_TEN_BOUGHT],
  },
  {
    id: 52,
    name: "Эра Автоматизации",
    description: "Улучшите интервалы АвтоПокупщиков Измерений Антиматерии и улучшений Скорости Тика.",
    checkRequirement: () => Autobuyer.antimatterDimension.zeroIndexed.concat(Autobuyer.tickspeed)
      .every(a => a.isUnlocked && a.hasMaxedInterval),
    checkEvent: [GAME_EVENT.REALITY_RESET_AFTER, GAME_EVENT.REALITY_UPGRADE_TEN_BOUGHT]
  },
  {
    id: 53,
    name: "Точно того не стоит",
    description: "Улучшите интервалы всех нормальных АвтоПокупщиков до максимума.",
    // The upgradeable autobuyers are dimensions, tickspeed, dimension boost,
    // galaxy, and big crunch (the ones you get from normal challenges).
    // We don't count autobuyers which can be upgraded via e.g. perks as upgradeable.
    checkRequirement: () => Autobuyers.upgradeable
      .every(a => a.isUnlocked && a.hasMaxedInterval),
    checkEvent: [GAME_EVENT.REALITY_RESET_AFTER, GAME_EVENT.REALITY_UPGRADE_TEN_BOUGHT]
  },
  {
    id: 54,
    name: "Это БЫСТРЕЕ!",
    get description() { return `Бесконечность за ${formatInt(10)} минут или меньше.`; },
    checkRequirement: () => Time.thisInfinityRealTime.totalMinutes <= 10,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() { return `Начинайте с ${format(5e5)} антиматерии.`; },
    effect: 5e5
  },
  {
    id: 55,
    name: "Навсегда - не так уж долго",
    get description() { return `Бесконечность за ${formatInt(1)} минуту или меньше.`; },
    checkRequirement: () => Time.thisInfinityRealTime.totalMinutes <= 1,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() { return `Начинайте с ${format(5e10)} антиматерии.`; },
    effect: 5e10
  },
  {
    id: 56,
    name: "Много Смертей",
    get description() {
      return `Пройдите Челлендж 2ого АвтоПокупщика Измерений Антиматерии за ${formatInt(3)} минуты или меньше.`;
    },
    checkRequirement: () => NormalChallenge(2).isOnlyActiveChallenge && Time.thisInfinityRealTime.totalMinutes <= 3,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() {
      return `Все Измерения Антиматерии сильнее первые ${formatInt(3)} минуты Бесконечности.`;
    },
    effect: () => Math.max(6 / (Time.thisInfinity.totalMinutes + 3), 1),
    effectCondition: () => Time.thisInfinity.totalMinutes < 3,
    formatEffect: value => `${formatX(value, 2, 2)}`
  },
  {
    id: 57,
    name: "Подарок Богов",
    get description() {
      return `Пройдите Челлендж АвтоПокупщика 8ого Измерения Антиматерии за ${formatInt(3)} минуты или меньше.`;
    },
    checkRequirement: () => NormalChallenge(8).isOnlyActiveChallenge && Time.thisInfinityRealTime.totalMinutes <= 3,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() {
      return `Жертвование Измерений сильнее.
      ${Sacrifice.getSacrificeDescription({ "Achievement32": true, "Achievement57": false, "Achievement88": false })} ➜
      ${Sacrifice.getSacrificeDescription({ "Achievement32": true, "Achievement57": true, "Achievement88": false })}`;
    },
    effect: 0.1
  },
  {
    id: 58,
    name: "Всё в порядке.",
    get description() { return `Пройдите Челлендж АвтоПокупщика Скорости Тика за ${formatInt(3)} минуты или меньше.`; },
    checkRequirement: () => NormalChallenge(9).isOnlyActiveChallenge && Time.thisInfinityRealTime.totalMinutes <= 3,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() {
      return `Повысьте множитель за покупку ${formatInt(10)} Измерений Антиматерии на +${formatPercents(0.01)}.`;
    },
    effect: 1.01
  },
  {
    id: 61,
    name: "Накаченный",
    get description() {
      return `Улучшите объем всех АвтоПокупщиков Измерений Антиматрии до
        ${formatInt(Autobuyer.antimatterDimension.bulkCap)}.`;
    },
    checkRequirement: () => Autobuyer.antimatterDimension.zeroIndexed.every(x => x.hasMaxedBulk),
    checkEvent: [GAME_EVENT.REALITY_RESET_AFTER, GAME_EVENT.REALITY_UPGRADE_TEN_BOUGHT,
      GAME_EVENT.SAVE_CONVERTED_FROM_PREVIOUS_VERSION],
    reward: "Объем АвтоПокупщиков теперь неограничен."
  },
  {
    id: 62,
    name: "О, привет... Ты всё ещё тут?",
    get description() { return `Достигните ${format(DC.E8)} Очков Бесконечности в минуту.`; },
    checkRequirement: () => Player.bestRunIPPM.exponent >= 8,
    checkEvent: GAME_EVENT.BIG_CRUNCH_AFTER
  },
  {
    id: 63,
    name: "Новое начало",
    description: "Начните поколение Мощности Бесконечности.",
    checkRequirement: () => Currency.infinityPower.gt(1),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER
  },
  {
    id: 64,
    name: "Ноль Смертей",
    description: "Дойдите до Бесконечности без Бустов Измерений или Галактик Антиматерии внутри Нормального Челленджа.",
    checkRequirement: () => player.galaxies === 0 && DimBoost.purchasedBoosts === 0 && NormalChallenge.isRunning,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() { return `Измерения Антиматерии 1-4 на ${formatPercents(0.25)} сильнее.`; },
    effect: 1.25
  },
  {
    id: 65,
    name: "Тоже-мне-испытание",
    get description() { return `Пройдите все Нормальные Челленджи в сумме менее чем за ${formatInt(3)} минуты.`; },
    checkRequirement: () => Time.challengeSum.totalMinutes < 3,
    checkEvent: [GAME_EVENT.BIG_CRUNCH_AFTER, GAME_EVENT.REALITY_RESET_AFTER],
    get reward() {
      return `Все Измерения Антиматерии сильнее в первые 3 ${formatInt(3)} минуты Бесконечностей,
      но только в Челленджах.`;
    },
    effect: () => (Player.isInAnyChallenge ? Math.max(4 / (Time.thisInfinity.totalMinutes + 1), 1) : 1),
    effectCondition: () => Player.isInAnyChallenge && Time.thisInfinity.totalMinutes < 3,
    formatEffect: value => `${formatX(value, 2, 2)}`
  },
  {
    id: 66,
    name: "Быстрее чем картошина в квадрате",
    get description() { return `Достигните ${format(DC.E58)} тиков в секунду.`; },
    checkRequirement: () => Tickspeed.current.exponent <= -55,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    get reward() { return `Начальная скорость тика умножена на ${formatX(1.02, 0, 2)}.`; },
    effect: 0.98
  },
  {
    id: 67,
    name: "Бесконечно Испытательный",
    description: "Пройдите Бесконечный Челлендж.",
    checkRequirement: () => InfinityChallenges.completed.length > 0,
    checkEvent: [GAME_EVENT.INFINITY_CHALLENGE_COMPLETED, GAME_EVENT.REALITY_RESET_AFTER]
  },
  {
    id: 68,
    name: "Ты сделал это снова только для достижения, так ведь?",
    get description() {
      return `Пройдите Челлендж АвтоПокупщика 3его Измерения Антиматерии за ${formatInt(10)} секунд или меньше.`;
    },
    checkRequirement: () => NormalChallenge(3).isOnlyActiveChallenge && Time.thisInfinityRealTime.totalSeconds <= 10,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() { return `1ые Измерения Антиматерии на ${formatPercents(0.5)} сильнее.`; },
    effect: 1.5
  },
  {
    id: 71,
    name: "Ошибка 909: Измерение не найдено",
    description:
      `Достигните Бесконечности только с одним Измерением Бесконечности, без Бустов Измерений или Галактик Антиматерии,
      находясь внутри Челленджа АвтоПокупщика 2ого Измерения Антиматерии.`,
    checkRequirement: () =>
      NormalChallenge(2).isOnlyActiveChallenge &&
      AntimatterDimension(1).amount.eq(1) &&
      DimBoost.purchasedBoosts === 0 &&
      player.galaxies === 0,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() { return `1ые Измерения Антиматерии в ${formatInt(3)} раза сильнее.`; },
    effect: 3
  },
  {
    id: 72,
    name: "Не могу удержать все эти Бесконечности",
    get description() {
      return `Сделайте все множители Измерений Антиматрии больше ${formatX(Decimal.NUMBER_MAX_VALUE, 1)}.`;
    },
    checkRequirement: () => AntimatterDimensions.all.every(x => x.multiplier.gte(Decimal.NUMBER_MAX_VALUE)),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    get reward() { return `Все Измерения Антиматерии на ${formatPercents(0.1)} сильнее.`; },
    effect: 1.1
  },
  {
    id: 73,
    name: "ЭТОГО ДОСТИЖЕНИЯ НЕ СУЩЕСТВУЕТ",
    get description() { return `Получите ${formatPostBreak(DC.D9_9999E9999, 4)} антиматерии.`; },
    checkRequirement: () => Currency.antimatter.gte(DC.D9_9999E9999),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    reward: "Измерения Антиматерии получают множитель, основанный на текущей антиматерии.",
    effect: () => Currency.antimatter.value.pow(0.00002).plus(1),
    formatEffect: value => `${formatX(value, 2, 2)}`
  },
  {
    id: 74,
    name: "Ни одной потерянной секунды",
    get description() { return `Пройдите все Нормальные Челленджи быстрее чем за 5 ${formatInt(5)} секунд в сумме.`; },
    checkRequirement: () => Time.challengeSum.totalSeconds < 5,
    checkEvent: [GAME_EVENT.BIG_CRUNCH_AFTER, GAME_EVENT.REALITY_RESET_AFTER],
    get reward() { return `Все Измерения Антиматерии на ${formatPercents(0.4)} сильнее, но только в челленджах.`; },
    effect: 1.4,
    effectCondition: () => Player.isInAnyChallenge
  },
  {
    id: 75,
    name: "НОВЫЕ ИЗМЕРЕНИЯ???",
    description: "Разблокируйте 4ое Измерение Бесконечности.",
    checkRequirement: () => InfinityDimension(4).isUnlocked,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    reward: "Ваш бонус Достижений влияет на Измерения Бесконечности.",
    effect: () => Achievements.power
  },
  {
    id: 76,
    name: "Каждому Измерению по одному",
    get description() { return `Играйте на протяжении ${formatInt(8)} дней.`; },
    checkRequirement: () => Time.totalTimePlayed.totalDays >= 8,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    reward: "Невероятно маленький множитель к Измерениям Антиматерии на основе сыгранного времени.",
    effect: () => Math.max(Math.pow(Time.totalTimePlayed.totalDays / 2, 0.05), 1),
    formatEffect: value => `${formatX(value, 2, 2)}`
  },
  {
    id: 77,
    name: "1 Миллион это много",
    get description() { return `Достигните ${format(1e6)} Мощности Бесконечности.`; },
    checkRequirement: () => Currency.infinityPower.exponent >= 6,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER
  },
  {
    id: 78,
    name: "Не успеешь и глазом моргнуть",
    get description() { return `Бесконечность за ${formatInt(250)}мс.`; },
    checkRequirement: () => Time.thisInfinityRealTime.totalMilliseconds <= 250,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() {
      return `Начнайте с ${format(5e25)} антиматерии.`;
    },
    effect: 5e25
  },
  {
    id: 81,
    name: "Игровой Дизайн - моя страсть",
    get description() { return `Пройдите Бесконечный Челлендж 5 за ${formatInt(15)} секунд или меньше.`; },
    checkRequirement: () => InfinityChallenge(5).isRunning && Time.thisInfinityRealTime.totalSeconds <= 15,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE
  },
  {
    id: 82,
    name: "Анти-антииспытанный",
    get description() { return `Пройдите все ${formatInt(8)} Бесконечных Челленджей.`; },
    checkRequirement: () => InfinityChallenges.completed.length === 8,
    checkEvent: [GAME_EVENT.INFINITY_CHALLENGE_COMPLETED, GAME_EVENT.REALITY_RESET_AFTER],
  },
  {
    id: 83,
    name: "МОЖНО ПОЛУЧИТЬ 50 ГАЛАКТИК?!?!",
    get description() { return `Получите ${formatInt(50)} Галактик Антиматерии.`; },
    checkRequirement: () => player.galaxies >= 50,
    checkEvent: GAME_EVENT.GALAXY_RESET_AFTER,
    get reward() { return `Скорость Тика на ${formatPercents(0.05)} больше за Галактику Антиматерии.`; },
    effect: () => DC.D0_95.pow(player.galaxies),
    formatEffect: value => `${formatX(value.recip(), 2, 2)}`
  },
  {
    id: 84,
    name: "У меня есть немного для остальных",
    get description() { return `Достигните ${formatPostBreak("1e35000")} антиматерии.`; },
    checkRequirement: () => Currency.antimatter.exponent >= 35000,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    reward: "Чем больше непотраченной антиматерии у вас есть, тем сильнее Измерения Антиматерии.",
    effect: () => Currency.antimatter.value.pow(0.00002).plus(1),
    formatEffect: value => `${formatX(value, 2, 2)}`
  },
  {
    id: 85,
    name: "ВСЕ ТВОЙ ОБ ТЕПЕРЬ НАШ ОБ",
    get description() { return `Большой Хруст за ${format(DC.E150)} Очков Бесконечности.`; },
    checkRequirement: () => gainedInfinityPoints().exponent >= 150,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() { return `Дополнительный ${formatX(4)} множитель к Очкам Бесконечности.`; },
    effect: 4
  },
  {
    id: 86,
    name: "Бро, ты вообще гнешь время?",
    get description() { return `Достигните ускорения в ${formatX(1000)} за улучшение Скорости Тика.`; },
    checkRequirement: () => Tickspeed.multiplier.recip().gte(1000),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    get reward() { return `Все Галактики на ${formatPercents(0.01)} сильнее.`; },
    effect: 1.01
  },
  {
    id: 87,
    name: "2 МИЛЛИОНА БЕСКОНЕЧНОСТЕЙ",
    get description() { return `Достигните Бесконечности ${format(DC.D2E6)} раз.`; },
    checkRequirement: () => Currency.infinities.gt(DC.D2E6),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    get reward() {
      return `Бесконечности длиннее ${formatInt(5)} секунд
      дают в ${formatX(250)} раз больше Бесконечностей.`;
    },
    effect: 250,
    effectCondition: () => Time.thisInfinity.totalSeconds > 5
  },
  {
    id: 88,
    name: "Очередная отсылка на бесконечность",
    get description() {
      return `Получите множитель в ${formatX(Decimal.NUMBER_MAX_VALUE, 1, 0)} за одно Жертвование Измерений.`;
    },
    checkRequirement: () => Sacrifice.nextBoost.gte(Decimal.NUMBER_MAX_VALUE),
    checkEvent: GAME_EVENT.SACRIFICE_RESET_BEFORE,
    get reward() {
      return `Жертвование Измерений сильнее.
      ${Sacrifice.getSacrificeDescription({ "Achievement32": true, "Achievement57": true, "Achievement88": false })} ➜
      ${Sacrifice.getSacrificeDescription({ "Achievement32": true, "Achievement57": true, "Achievement88": true })}`;
    },
    effect: 0.1
  },
  {
    id: 91,
    name: "Смехотворная скорость",
    get description() {
      return `Большой Хруст за ${format(DC.E200)} Очков Бесконечности за ${formatInt(2)} секунды или меньше.`;
    },
    checkRequirement: () => gainedInfinityPoints().exponent >= 200 && Time.thisInfinityRealTime.totalSeconds <= 2,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() {
      return `Все Измерения Антиматерии значительно сильнее
      первые ${formatInt(5)} секунд Бесконечности.`;
    },
    effect: () => Math.max((5 - Time.thisInfinity.totalSeconds) * 60, 1),
    effectCondition: () => Time.thisInfinity.totalSeconds < 5,
    formatEffect: value => `${formatX(value, 2, 2)}`
  },
  {
    id: 92,
    name: "Я НИ ПЕРЕД КЕМ НЕ ЗАТОРМОЖУ!",
    get description() {
      return `Большой Хруст за ${format(DC.E250)} Очков Бесконечности за ${formatInt(20)} секунд или меньше.`;
    },
    checkRequirement: () => gainedInfinityPoints().exponent >= 250 && Time.thisInfinityRealTime.totalSeconds <= 20,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() {
      return `Все Измерения Антиматерии значительно сильнее
      первые ${formatInt(60)} секунд Бесконечности.`;
    },
    effect: () => Math.max((1 - Time.thisInfinity.totalMinutes) * 100, 1),
    effectCondition: () => Time.thisInfinity.totalMinutes < 1,
    formatEffect: value => `${formatX(value, 2, 2)}`
  },
  {
    id: 93,
    name: "МАКСИМАЛЬНАЯ ПЕРЕГРУЗКА",
    get description() { return `Большой Хруст за ${format(DC.E300)} Очков Бесконечности.`; },
    checkRequirement: () => gainedInfinityPoints().exponent >= 300,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    get reward() { return `Дополнительный множитель в ${formatX(4)} к Очкам Бесконечности.`; },
    effect: 4
  },
  {
    id: 94,
    name: "4.3333 минуты Бесконечности",
    get description() { return `Достигните ${format(DC.E260)} Мощности Бесконечности.`; },
    checkRequirement: () => Currency.infinityPower.exponent >= 260,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    reward: "Заработок Мощности Бесконечности удваивается.",
    effect: 2
  },
  {
    id: 95,
    name: "Это безопасно?",
    get description() {
      return `Получите ${format(Decimal.NUMBER_MAX_VALUE, 1, 0)} Репликантов за ${formatInt(1)} час.`;
    },
    get reward() { return `Вы сохраняете Репликантов и ${formatInt(1)} Галактику Репликантов после Бесконечности.`; },
    checkRequirement: () =>
      (Replicanti.amount.eq(Decimal.NUMBER_MAX_VALUE) || player.replicanti.galaxies > 0) &&
      Time.thisInfinityRealTime.totalHours <= 1,
    checkEvent: GAME_EVENT.REPLICANTI_TICK_AFTER
  },
  {
    id: 96,
    name: "Время относительно",
    description: "Станьте Вечным.",
    checkRequirement: () => true,
    checkEvent: GAME_EVENT.ETERNITY_RESET_BEFORE
  },
  {
    id: 97,
    name: "Как по лего ходить",
    get description() {
      return `Пройдите все Бесконечные Челленджи быстрее чем за ${format(6.66, 2, 2)} секунд в сумме.`;
    },
    checkRequirement: () => Time.infinityChallengeSum.totalSeconds < 6.66,
    checkEvent: [GAME_EVENT.BIG_CRUNCH_AFTER, GAME_EVENT.REALITY_RESET_AFTER],
  },
  {
    id: 98,
    name: "0 градусов от Бесконечности",
    description: "Разблокируйте 8ое Измерение Бесконечности.",
    checkRequirement: () => InfinityDimension(8).isUnlocked,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER
  },
  {
    id: 101,
    name: "Ни у кого нет на это 8ремени",
    description: "Вечность без покупки Измерений Антиматерии 1-7.",
    checkRequirement: () => player.requirementChecks.eternity.onlyAD8,
    checkEvent: GAME_EVENT.ETERNITY_RESET_BEFORE
  },
  {
    id: 102,
    name: "Эта миля заняла Вечность",
    description: "Достигните всех Рубежей Вечности.",
    checkRequirement: () => EternityMilestone.all.every(m => m.isReached),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER
  },
  {
    id: 103,
    name: "Tätä saavutusta ei ole olemassa II",
    get description() { return `Достигните ${formatPostBreak(DC.D9_99999E999, 5, 0)} Очков Бесконечности.`; },
    checkRequirement: () => Currency.infinityPoints.exponent >= 1000,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    get reward() {
      return `Формула Очков Бесконечности улучшается. log(x)/${formatInt(308)} ➜ log(x)/${formatFloat(307.8, 1)}`;
    },
    effect: 307.8
  },
  {
    id: 104,
    name: "Это была не Вечность",
    get description() { return `Вечность за ${formatInt(30)} секунд.`; },
    checkRequirement: () => Time.thisEternity.totalSeconds <= 30,
    checkEvent: GAME_EVENT.ETERNITY_RESET_BEFORE,
    get reward() { return `Начнинайте Вечность с ${format(5e25)} Очками Бесконечности.`; },
    effect: 5e25
  },
  {
    id: 105,
    name: "Бесконечное Время",
    get description() { return `Получите ${formatInt(308)} улучшений Скорости Тика от Измерений Времени.`; },
    checkRequirement: () => player.totalTickGained >= 308,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    reward: "Измерения времени получают множитель на основе скорости тика.",
    effect: () => Tickspeed.perSecond.pow(0.000005),
    formatEffect: value => `${formatX(value, 2, 2)}`
  },
  {
    id: 106,
    name: "Рой",
    get description() { return `Получите ${formatInt(10)} Галактик Репликантов за ${formatInt(15)} секунд.`; },
    checkRequirement: () => Replicanti.galaxies.total >= 10 && Time.thisInfinity.totalSeconds <= 15,
    checkEvent: GAME_EVENT.REPLICANTI_TICK_AFTER
  },
  {
    id: 107,
    name: "Тебе правда нужно руководство для этого?",
    get description() { return `Вечность с менее чем ${formatInt(10)} Бесконечностями.`; },
    checkRequirement: () => Currency.infinities.lt(10),
    checkEvent: GAME_EVENT.ETERNITY_RESET_BEFORE
  },
  {
    id: 108,
    name: "У нас ХВАТАЕТ на 9",
    get description() { return `Вечность с ровно ${formatInt(9)} Репликантами.`; },
    checkRequirement: () => Replicanti.amount.round().eq(9),
    checkEvent: GAME_EVENT.ETERNITY_RESET_BEFORE
  },
  {
    id: 111,
    name: "Йо чувак, я слышал тебе нравятся бесконечности...",
    get description() {
      return `Сделайте так, что количество Очков Бесконечности в каждой из последних ${formatInt(10)} Бесконечностей как
      минимум в ${format(Decimal.NUMBER_MAX_VALUE, 1, 0)} раз превышает количество очков в предыдущей Бесконечности.`;
    },
    checkRequirement: () => {
      if (player.records.recentInfinities.some(i => i[0] === Number.MAX_VALUE)) return false;
      const infinities = player.records.recentInfinities.map(run => run[2]);
      for (let i = 0; i < infinities.length - 1; i++) {
        if (infinities[i].lt(infinities[i + 1].times(Decimal.NUMBER_MAX_VALUE))) return false;
      }
      return true;
    },
    checkEvent: GAME_EVENT.BIG_CRUNCH_AFTER,
    reward: "Антиматерия не сбрасывается после Бустов Измерений или Галактик Антиматерии."
  },
  {
    id: 112,
    name: "Никогда больше",
    get description() { return `Пройдите все Бесконечные Челленджи за ${formatInt(750)}мс в сумме или быстрее.`; },
    checkRequirement: () => Time.infinityChallengeSum.totalMilliseconds < 750,
    checkEvent: [GAME_EVENT.BIG_CRUNCH_AFTER, GAME_EVENT.REALITY_RESET_AFTER]
  },
  {
    id: 113,
    name: "Вечности - это новые Бесконечности",
    get description() { return `Вечность за ${formatInt(250)}мс.`; },
    checkRequirement: () => Time.thisEternity.totalMilliseconds <= 250,
    checkEvent: GAME_EVENT.ETERNITY_RESET_BEFORE,
    get reward() { return `Заработок Вечностей ${formatX(2)}.`; },
    effect: 2,
  },
  {
    id: 114,
    name: "Ты - ошибка",
    description: "Провалите Вечный Челлендж.",
    checkRequirement: () => true,
    checkEvent: GAME_EVENT.CHALLENGE_FAILED,
    reward: "Угасающее чувство достижения.",
    effect: () => "Чувство достижения (угасает)"
  },
  {
    id: 115,
    name: "Хочу, чтобы у меня было 7 Вечностей",
    description: "Начните Бесконечный Челлендж внутри Вечного Челленджа.",
    checkEvent: GAME_EVENT.ACHIEVEMENT_EVENT_OTHER,
  },
  {
    id: 116,
    name: "Мне правда нужна бесконечность?",
    get description() { return `Вечность только с  ${formatInt(1)} Бесконечностью.`; },
    checkRequirement: () => Currency.infinities.lte(1),
    checkEvent: GAME_EVENT.ETERNITY_RESET_BEFORE,
    reward: "Множитель к Очкам Бесконечности на основе Бесконечностей.",
    effect: () => Decimal.pow(Currency.infinitiesTotal.value.clampMin(1), LOG10_2 / 4).powEffectOf(TimeStudy(31)),
    cap: () => Effarig.eternityCap,
    formatEffect: value => {
      // Since TS31 is already accounted for in the effect prop, we need to "undo" it to display the base value here
      const mult = formatX(value, 2, 2);
      return TimeStudy(31).canBeApplied
        ? `${formatX(value.pow(1 / TimeStudy(31).effectValue), 2, 1)} (После ВИ31: ${mult})`
        : mult;
    }
  },
  {
    id: 117,
    name: "Шестёрочка теперь продает Бусты Измерений!",
    get description() { return `Купите ${formatInt(750)} Бустов Измерений за раз.`; },
    checkRequirement: ([bulk]) => bulk >= 750,
    checkEvent: GAME_EVENT.DIMBOOST_AFTER,
    get reward() {
      return `Множитель от Бустов Измерений к Измерениям Антиматерии на ${formatPercents(0.01)} больше.`;
    },
    effect: 1.01
  },
  {
    id: 118,
    name: "ОНО БОЛЬШЕ 9000",
    get description() { return `Достигните общего множителя Жертвования Измерений в ${formatPostBreak(DC.E9000)}.`; },
    checkRequirement: () => Sacrifice.totalBoost.exponent >= 9000,
    checkEvent: GAME_EVENT.SACRIFICE_RESET_AFTER,
    reward: `Жертвование измерений не сбрасывает Измерения Антиматерии,
      а АвтоПокупщик активируется каждый тик если включен.`,
  },
  {
    id: 121,
    name: "Можно ли получить бесконечные ОБ?",
    get description() { return `Достигните ${formatPostBreak("1e30008")} Очков Бесконечности.`; },
    checkRequirement: () => Currency.infinityPoints.exponent >= 30008,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER
  },
  {
    id: 122,
    name: "Ты уже мёртв.",
    description: "Вечность без покупки Измерений Антиматерии 2-8.",
    checkRequirement: () => player.requirementChecks.eternity.onlyAD1,
    checkEvent: GAME_EVENT.ETERNITY_RESET_BEFORE
  },
  {
    id: 123,
    name: "5 вечностей до обновления",
    get description() { return `Пройдите ${formatInt(50)} уникальных уровней Вечных Челленджей.`; },
    checkRequirement: () => EternityChallenges.completions >= 50,
    checkEvent: GAME_EVENT.ETERNITY_RESET_AFTER
  },
  {
    id: 124,
    name: "Долгосрочные отношения",
    get description() {
      return `Сдалайте так, чтобы Мощность Бесконечности в секунду превышала Мощность Бесконечности
      ${formatInt(60)} секунд подряд внутри одной Бесконечности.`;
    },
    checkRequirement: () => AchievementTimers.marathon2
      .check(
        !EternityChallenge(7).isRunning &&
        InfinityDimension(1).productionPerSecond.gt(Currency.infinityPower.value),
        60
      ),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER
  },
  {
    id: 125,
    name: "Как пирование на спине",
    get description() {
      return `Достигните ${format(DC.E90)} Очков Бесконечности без Бесконечностей
      или 1ых Измерений Антиматерии в вашей текущей Вечности.`;
    },
    checkRequirement: () => Currency.infinityPoints.exponent >= 90 &&
      player.requirementChecks.eternity.noAD1 && Currency.infinities.eq(0),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    reward: "Множитель Очков Бесконечности на основе времени, проведённого в этой Бесконечности.",
    effect() {
      const thisInfinity = Time.thisInfinity.totalSeconds * 10 + 1;
      return DC.D2.pow(Math.log(thisInfinity) * Math.min(Math.pow(thisInfinity, 0.11), 500));
    },
    cap: () => Effarig.eternityCap,
    formatEffect: value => `${formatX(value, 2, 2)}`
  },
  {
    id: 126,
    name: "Популярная музыка",
    get description() {
      return `Получите в ${formatInt(180)} раз больше Галактик Репликантов, чем Галактик Антиматерии.`;
    },
    checkRequirement: () => Replicanti.galaxies.total >= 180 * player.galaxies && player.galaxies > 0,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    get reward() {
      return `Галактики Репликантов делят Репликантов на ${format(Decimal.NUMBER_MAX_VALUE, 1, 0)}
      вместо того чтобы сбрасывать их до ${formatInt(1)}.`;
    },
  },
  {
    id: 127,
    name: "Но я хотел ещё один слой престижа...",
    get description() { return `Достигните ${format(Decimal.NUMBER_MAX_VALUE, 1, 0)} Очков Вечности.`; },
    checkRequirement: () => Currency.eternityPoints.gte(Decimal.NUMBER_MAX_VALUE),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER
  },
  {
    id: 128,
    name: "Что я должен сделать чтобы избавиться от тебя",
    get description() {
      return `Достигните ${formatPostBreak("1e22000")} Очков Бесконечности без Временных Исследований.`;
    },
    checkRequirement: () => Currency.infinityPoints.exponent >= 22000 && player.timestudy.studies.length === 0,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    reward: "Измерения Времени умножены на количество имеющихся у вас Временных Исследований.",
    effect: () => Math.max(player.timestudy.studies.length, 1),
    formatEffect: value => `${formatX(value)}`
  },
  {
    id: 131,
    name: "Никакого этичного потребления",
    get description() { return `Получите ${format(DC.D2E9)} Запасённых Бесконечностей.`; },
    checkRequirement: () => Currency.infinitiesBanked.gt(DC.D2E9),
    checkEvent: [GAME_EVENT.ETERNITY_RESET_AFTER, GAME_EVENT.SAVE_CONVERTED_FROM_PREVIOUS_VERSION],
    get reward() {
      return `Вы зарабатываете в ${formatX(2)} раза больше Бесконечностей и
      после Вечности вы навсегда сохраняете ${formatPercents(0.05)} ваших Бесконечностей в качестве Запасённых
      Бесконечностей.`;
    },
    effects: {
      infinitiesGain: 2,
      bankedInfinitiesGain: () => Currency.infinities.value.times(0.05).floor()
    }

  },
  {
    id: 132,
    name: "Уникальные снежинки",
    get description() {
      return `Получите ${formatInt(569)} Галактик Антиматерии без получения
        Галактик Репликантов в вашей текущей Вечности.`;
    },
    checkRequirement: () => player.galaxies >= 569 && player.requirementChecks.eternity.noRG,
    checkEvent: GAME_EVENT.GALAXY_RESET_AFTER,
    reward: "Получите множитель к Тахион Частицам и Растянутому времени на основе Галактик Антиматерии.",
    effect: () => 1.22 * Math.max(Math.pow(player.galaxies, 0.04), 1),
    formatEffect: value => `${formatX(value, 2, 2)}`
  },
  {
    id: 133,
    name: "Мне всё равно никогда не нравились все эти Бесконечности",
    get description() {
      return `Достигните ${formatPostBreak(DC.E200000)} Очков Бесконечности без
      покупки Измерений Бесконечности или ${formatX(2)} множителя Очков Бесконечности.`;
    },
    checkRequirement: () =>
      Array.dimensionTiers.map(InfinityDimension).every(dim => dim.baseAmount === 0) &&
      player.IPMultPurchases === 0 &&
      Currency.infinityPoints.exponent >= 200000,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    reward: "Все Бесконечные Челленджи открыты и пройдены в новых Вечностях."
  },
  {
    id: 134,
    name: "Когда уже будет достаточно?",
    get description() { return `Достигните ${formatPostBreak(DC.E18000)} Репликантов.`; },
    checkRequirement: () => Replicanti.amount.exponent >= 18000,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    get reward() {
      return `Вы получаете Репликантов в ${formatInt(2)} раза быстрее до ${format(replicantiCap(), 1)} Репликантов.`;
    }
  },
  {
    id: 135,
    name: "Быстрее чем картошина^286078",
    get description() { return `Получите более чем ${formatPostBreak("1e8296262")} тиков в секунду.`; },
    checkRequirement: () => Tickspeed.current.exponent <= -8296262,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER
  },
  {
    id: 136,
    name: "Я тебе уже говорил, время относительно",
    description: "Растяните время.",
    checkEvent: GAME_EVENT.ACHIEVEMENT_EVENT_OTHER,
  },
  {
    id: 137,
    name: "Теперь ты думаешь с задержкой!",
    get description() {
      return `Получите ${formatPostBreak("1e260000")} антиматерии
      за ${formatInt(1)} минуту или меньше в Растяжении.`;
    },
    checkRequirement: () =>
      Currency.antimatter.exponent >= 260000 &&
      Time.thisEternity.totalMinutes <= 1 &&
      player.dilation.active,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    get reward() { return `Зарабатывайте ${formatX(2)} Растянутого Времени и Временных Теорем в растяжении.`; },
    effect: () => (player.dilation.active ? 2 : 1),
  },
  {
    id: 138,
    name: "Вот то, что мне нужно сделать, чтобы от тебя избавиться.",
    get description() {
      return `Достигните ${
        formatPostBreak("1e26000")} Очков Бесконечности не используя Временные Исследования, в Растяжении.`;
    },
    checkRequirement: () =>
      player.timestudy.studies.length === 0 &&
      player.dilation.active &&
      Currency.infinityPoints.exponent >= 26000,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    reward: "Убирает недостатки от Временного Исследования 131 и 133 в Активном и Бездействующем путях " +
    "Временных Исследований."
  },
  {
    id: 141,
    name: "Он возвращается в Реальность",
    description: "Сделайте новую Реальность.",
    checkRequirement: () => true,
    checkEvent: GAME_EVENT.REALITY_RESET_BEFORE,
    get reward() {
      return `${formatX(4)} заработок Очков Бесконечности, и повышение множителя за покупку ${formatInt(10)}
      Измерений Антиматерии на +${format(0.1, 0, 1)}.`;
    },
    effects: {
      ipGain: 4,
      buyTenMult: 0.1
    }
  },
  {
    id: 142,
    name: "Как это работает?",
    description: "Откройте Автоматизатор.",
    checkRequirement: () => Player.automatorUnlocked,
    checkEvent: [GAME_EVENT.REALITY_RESET_AFTER, GAME_EVENT.REALITY_UPGRADE_BOUGHT, GAME_EVENT.PERK_BOUGHT,
      GAME_EVENT.BLACK_HOLE_UNLOCKED],
    get reward() { return `Бусты Измерений на ${formatPercents(0.5)} сильнее.`; },
    effect: 1.5,
  },
  {
    id: 143,
    name: "Йо чувак, я слышал тебе нравятся рескины...",
    get description() {
      return `Сделайте так, что количество Очков Вечности в каждой из последних ${formatInt(10)} Вечностей как
      минимум в ${format(Decimal.NUMBER_MAX_VALUE, 1, 0)} раз превышает количество очков в предыдущей Вечности.`;
    },
    checkRequirement: () => {
      if (player.records.recentEternities.some(i => i[0] === Number.MAX_VALUE)) return false;
      const eternities = player.records.recentEternities.map(run => run[2]);
      for (let i = 0; i < eternities.length - 1; i++) {
        if (eternities[i].lt(eternities[i + 1].times(Decimal.NUMBER_MAX_VALUE))) return false;
      }
      return true;
    },
    checkEvent: GAME_EVENT.ETERNITY_RESET_AFTER,
    reward: "Галактики больше не сбрасывают Бусты Измерений."
  },
  {
    id: 144,
    name: "Это отсылка на Интерстеллар?",
    description: "Разблокируйте Чёрную Дыру.",
    checkRequirement: () => BlackHole(1).isUnlocked,
    checkEvent: GAME_EVENT.BLACK_HOLE_UNLOCKED,
  },
  {
    id: 145,
    name: "Ты уверен что так и должно быть?",
    description: "Сделайте интервал какой-либо Чёрной Дыры меньше её времени действия.",
    checkRequirement: () => BlackHoles.list.some(bh => bh.interval < bh.duration),
    checkEvent: GAME_EVENT.BLACK_HOLE_UPGRADE_BOUGHT,
    get reward() { return `Интервалы Чёрных Дыр на ${formatPercents(0.1)} короче.`; },
    effect: 0.9
  },
  {
    id: 146,
    name: "Перки жизни",
    description: "Купите все Перки.",
    checkRequirement: () => player.reality.perks.size === Perks.all.length,
    checkEvent: GAME_EVENT.PERK_BOUGHT,
    get reward() { return `+${formatPercents(0.01)} редкости Глифов.`; },
    effect: 1
  },
  {
    id: 147,
    name: "Мастер Реальности",
    description: "Купите все Улучшения Реальности.",
    checkRequirement: () => RealityUpgrades.allBought,
    checkEvent: GAME_EVENT.REALITY_UPGRADE_BOUGHT,
    reward: "Разблокирована Тереза, Божество Реальности."
  },
  {
    id: 148,
    name: "Флэш Рояль",
    description: "Реальность с одним Глифом от каждого базового типа.",
    checkRequirement: () => BASIC_GLYPH_TYPES
      .every(type => Glyphs.activeList.some(g => g.type === type)),
    checkEvent: GAME_EVENT.REALITY_RESET_BEFORE,
    reward: "Полученный уровень Глифа увеличен на количество различных экипированных типов Глифов.",
    effect: () => (new Set(Glyphs.activeWithoutCompanion.map(g => g.type))).size,
    formatEffect: value => `+${formatInt(value)}`
  },
  {
    id: 151,
    name: "Тебе всё равно это было не нужно",
    get description() {
      return `Получите ${formatInt(800)} Галактик Антиматерии без
      покупки 8ых Измерений Антиматерии in your current Infinity.`;
    },
    checkRequirement: () => player.galaxies >= 800 && player.requirementChecks.infinity.noAD8,
    checkEvent: GAME_EVENT.GALAXY_RESET_AFTER,
    reward: "Разблокирован Ви, Божество Достижений."
  },
  {
    id: 152,
    name: "Ну чё там, есть у кого-нибудь эти Глифы?",
    get description() { return `Имейте ${formatInt(100)} Глифов в вашем инвентаре.`; },
    checkRequirement: () => Glyphs.inventoryList.length >= 100,
    checkEvent: GAME_EVENT.GLYPHS_CHANGED
  },
  {
    id: 153,
    name: "Больше похоже на \"реальнонеимеетзначения\"",
    description: "Реальность без производства антиматерии.",
    checkRequirement: () => player.requirementChecks.reality.noAM,
    checkEvent: GAME_EVENT.REALITY_RESET_BEFORE,
  },
  {
    id: 154,
    name: "Я - скорость",
    get description() { return `Реальность до ${formatInt(5)} секунд (игрового времени).`; },
    checkRequirement: () => Time.thisReality.totalSeconds <= 5,
    checkEvent: GAME_EVENT.REALITY_RESET_BEFORE,
    get reward() {
      return `${formatPercents(0.1)} шанс каждую Реальность на ${formatX(2)} Реальностей и Очков Перка.`;
    },
    effect: 0.1
  },
  {
    id: 155,
    name: "Достижение #15983",
    get description() { return `Играйте на протяжении ${formatFloat(13.7, 1)} миллиардов лет.`; },
    checkRequirement: () => Time.totalTimePlayed.totalYears > 13.7e9,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    get reward() { return `Время действия Чёрных Дыр на ${formatPercents(0.1)} длиннее.`; },
    effect: 1.1
  },
  {
    id: 156,
    name: "Недоучка в колледже",
    description: "Реальность без покупки Временных Теорем.",
    checkRequirement: () => player.requirementChecks.reality.noPurchasedTT,
    checkEvent: GAME_EVENT.REALITY_RESET_BEFORE,
    get reward() {
      return `Получите ${formatX(2.5, 0, 1)} сгенерированных Временных Теоремы и бесплатный купон в Макдак.`;
    },
    effect: 2.5
  },
  {
    id: 157,
    name: "Это супер эффективно!",
    get description() { return `Получите Глиф с ${formatInt(4)} эффектами.`; },
    checkRequirement: () => Glyphs.activeList.concat(Glyphs.inventoryList).map(
      glyph => getGlyphEffectsFromBitmask(glyph.effects, 0, 0)
        .filter(effect => effect.isGenerated).length
    ).max() >= 4,
    checkEvent: GAME_EVENT.GLYPHS_CHANGED
  },
  {
    id: 158,
    name: "Бро, ты, типа, внутри дыры?",
    description: "Сделайте обе Чёрные Дыры постоянными.",
    checkRequirement: () => BlackHole(1).isPermanent && BlackHole(2).isPermanent,
    checkEvent: GAME_EVENT.BLACK_HOLE_UPGRADE_BOUGHT,
    get reward() { return `Мощность Чёрных Дыр повышена на ${formatPercents(0.1)}.`; },
    effect: 1.1
  },
  {
    id: 161,
    name: "здесь-то ты и ошибаешься сынок",
    get description() { return `Заработайте ${formatPostBreak(DC.E1E8)} антиматерии в Растяжении.`; },
    checkRequirement: () => Currency.antimatter.exponent >= 100000000 && player.dilation.active,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER
  },
  {
    id: 162,
    name: "Переустановил игру и переподключился к серверу",
    description: "Имейте все Временные Исследования одновременно.",
    checkRequirement: () => player.timestudy.studies.length >= 58,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER
  },
  {
    id: 163,
    name: "На самом деле, очень легко! Едва ли недоразумение!",
    get description() {
      return `Пройдите все Вечные Челленджи ${formatInt(5)} раз быстрее чем за ${formatInt(1)}
      секунду (игрового времени) в вашей текущей Реальности.`;
    },
    checkRequirement: () => EternityChallenges.all.map(ec => ec.completions).min() >= 5 &&
      Time.thisReality.totalSeconds <= 1,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER
  },
  {
    id: 164,
    name: "Бесконечность умножить на два",
    get description() { return `Получите ${format(Decimal.NUMBER_MAX_VALUE, 1)} Бесконечностей.`; },
    checkRequirement: () => Currency.infinitiesTotal.gte(Decimal.NUMBER_MAX_VALUE),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    get reward() { return `Получайте ×${formatInt(1024)} больше Бесконечностей.`; },
    effect: 1024
  },
  {
    id: 165,
    name: "Безупречный баланс",
    get description() {
      return `Получите Глиф уровня ${formatInt(5000)} со всеми равными коэффициентами уровня Глифов .`;
    },
    checkRequirement: () => gainedGlyphLevel().actualLevel >= 5000 &&
      ["repl", "dt", "eternities"].every(
        i => player.celestials.effarig.glyphWeights[i] === player.celestials.effarig.glyphWeights.ep),
    checkEvent: GAME_EVENT.REALITY_RESET_BEFORE,
    reward: "Разблокируйте автоматическую оптимальную регулировку уровня Глифов."
  },
  {
    id: 166,
    name: "Найснайс.",
    get description() { return `Получите Глиф уровня ровно ${formatInt(6969)}.`; },
    checkRequirement: () => gainedGlyphLevel().actualLevel === 6969,
    checkEvent: GAME_EVENT.REALITY_RESET_BEFORE,
    get reward() { return `+${formatInt(69)} к уровню Глифа.`; },
    effect: 69
  },
  {
    id: 167,
    name: "Мистер Слой? Извините, вас нет в списке",
    get description() { return `Достигните ${format(Decimal.NUMBER_MAX_VALUE, 1, 0)} Машин Реальности.`; },
    checkRequirement: () => Currency.realityMachines.gte(Decimal.NUMBER_MAX_VALUE),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    reward: "Зарабатывайте больше Машин Реальности на основе текущих Машин Реальности.",
    effect: () => Math.clampMin(1, Currency.realityMachines.value.log2()),
    formatEffect: value => `${formatX(value, 2, 2)}`
  },
  {
    id: 168,
    name: "Воу, мы уже на полпути",
    get description() { return `Получите ${formatInt(50)} уровней Божественных Воспоминаний Ра.`; },
    checkRequirement: () => Ra.totalPetLevel >= 50,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    get reward() { return `Зарабатывайте на ${formatPercents(0.1)} больше Воспоминаний.`; },
    effect: 1.1
  },
  {
    id: 171,
    name: "Бог польщён",
    description: "Пожертвуйте Глиф каждого типа, которого можно пожертвовать, хотя бы однажды.",
    checkRequirement: () => Object.values(player.reality.glyphs.sac).every(s => s > 0),
    checkEvent: GAME_EVENT.GLYPHS_CHANGED,
    get reward() { return `Жертвование Глифов в ${formatX(2)} раза сильнее.`; },
    effect: 2,
  },
  {
    id: 172,
    name: "Автостопом по Реальности",
    get description() {
      return `Реальность за ${format(Decimal.NUMBER_MAX_VALUE, 1)} Машин Реальности без
      каких-либо Заряженных Улучшений Бесконечности, экипированных Глифов или покупки Исследований Триад.`;
    },
    checkRequirement: () => MachineHandler.gainedRealityMachines.gte(Decimal.NUMBER_MAX_VALUE) &&
      player.celestials.ra.charged.size === 0 && Glyphs.activeWithoutCompanion.length === 0 &&
      player.requirementChecks.reality.noTriads,
    checkEvent: GAME_EVENT.REALITY_RESET_BEFORE,
  },
  {
    id: 173,
    name: "Cet accomplissement n'existe pas III",
    get description() { return `Достигните ${formatPostBreak(DC.D9_99999E999, 5, 0)} Машин Реальности.`; },
    checkRequirement: () => player.reality.realityMachines.gte(DC.D9_99999E999),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER
  },
  {
    id: 174,
    name: "Разве у вас уже нет двух из них?",
    description: "Получите Сингулярность.",
    checkRequirement: () => true,
    checkEvent: GAME_EVENT.SINGULARITY_RESET_BEFORE
  },
  {
    id: 175,
    name: "Первый Антиисторик",
    get description() { return `Получите ${formatInt(Ra.alchemyResourceCap)} всех Алхимических Ресурсов.`; },
    checkRequirement: () => AlchemyResources.all.every(x => x.amount >= Ra.alchemyResourceCap),
    checkEvent: GAME_EVENT.REALITY_RESET_AFTER,
    get reward() {
      return `Синергизм может достигать более ${formatPercents(1)} и Импульс увеличивается на ${formatX(10)} быстрее.`;
    },
    effect: 10,
  },
  {
    id: 176,
    name: "Мама досчитала до трёх",
    description: "Аннигилируйте ваши Измерения Тёмной Материи.",
  },
  {
    id: 177,
    name: "Эта миля заняла Божество",
    description: "Достигните всех Рубежей Сингулярности хотя бы раз.",
    checkRequirement: () => SingularityMilestones.all.every(x => x.completions > 0),
    checkEvent: GAME_EVENT.SINGULARITY_RESET_AFTER,
  },
  {
    id: 178,
    name: "Разрушитель Миров",
    get description() { return `Получите ${formatInt(100000)} Галактик Антиматерии.`; },
    checkRequirement: () => player.galaxies >= 100000,
    checkEvent: GAME_EVENT.GALAXY_RESET_AFTER,
    get reward() { return `Все Галактики на ${formatPercents(0.01)} сильнее.`; },
    effect: 1.01
  },
  {
    id: 181,
    displayId: 666,
    name: "Антиматерия Измерений Этёрнал",
    description: "Обреките вашу Реальность.",
    checkRequirement: () => Pelle.isDoomed,
    checkEvent: GAME_EVENT.REALITY_RESET_AFTER,
  },
  {
    id: 182,
    name: "Ещё один раз",
    description: "Навсегда откройте назад все АвтоПокупщики Измерений Антиматерии.",
    checkRequirement: () => PelleUpgrade.antimatterDimAutobuyers1.canBeApplied &&
      PelleUpgrade.antimatterDimAutobuyers2.canBeApplied,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER
  },
  {
    id: 183,
    name: "Дéжà вЮюМ",
    description: "Пройдите Бесконечный Челлендж 5 пока Обречены.",
    checkRequirement: () => Pelle.isDoomed && InfinityChallenge(5).isCompleted,
    checkEvent: GAME_EVENT.INFINITY_CHALLENGE_COMPLETED,
    // Weirdly specific reward? Yes, its V's ST bonus because we forgot to disable it
    // when balancing Pelle and only realised too late.
    get reward() { return `Все Измерения Антиматерии подняты до ${formatPow(1.0812403840463596, 0, 3)}`; },
    effect: 1.0812403840463596
  },
  {
    id: 184,
    name: "Ты в отключке!",
    description: "Столкнитесь с третьим Ударом Пелле.",
    checkRequirement: () => PelleStrikes.eternity.hasStrike,
    checkEvent: GAME_EVENT.PELLE_STRIKE_UNLOCKED
  },
  {
    id: 185,
    name: "Минуло восемьдесят семь лет",
    description: "Столкнитесь с четвёртым Ударом Пелле.",
    checkRequirement: () => PelleStrikes.ECs.hasStrike,
    checkEvent: GAME_EVENT.PELLE_STRIKE_UNLOCKED
  },
  {
    id: 186,
    displayId: 181,
    name: "Нездоровая страсть",
    description: `Купите Временное Исследование 181 пока Обречены.`,
  },
  {
    id: 187,
    name: "Тот самый с Растянутым Временем",
    description: "Разблокируйте Растяжение пока Обречены.",
    checkRequirement: () => PelleStrikes.dilation.hasStrike,
    checkEvent: GAME_EVENT.PELLE_STRIKE_UNLOCKED,
    // We forgot to disable a singularity milestone while balancing Pelle; now it's disabled
    // and this upgrade has the same effect as it used to.
    get reward() {
      return `Повысьте множитель за многоразовое улучшение множителя Растянутого Времени
      на ${formatX(1.35, 0, 2)}.`;
    },
    effect: 1.35
  },
  {
    id: 188,
    name: "Конец",
    description: "Пройдите игру.",
    checkRequirement: () => GameEnd.endState > END_STATE_MARKERS.GAME_END && !GameEnd.removeAdditionalEnd,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER
  },
];
